import type {
  AsyncTaskStatusQueryKey,
  UseAsyncTaskStatusParams,
} from './types';

export const getAsyncTaskStatusQueryKey = (
  params: UseAsyncTaskStatusParams,
): AsyncTaskStatusQueryKey => ['common', 'asyncTaskStatuses', params];
